import { Flex, Box, Grid, HStack, Circle, Text, Skeleton } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import BorderedBox from '../layouts/BorderedBox';
import { IHardwareResults } from '../../config/interface';

interface ReviewVideosProps {
    recordId?: string;
    reviewer?: string;
    reviewStatus?: string;
    hardwareResults: IHardwareResults;
    enrollmentData?: any;
}

const HardwareResults: React.FC<ReviewVideosProps> = ({ hardwareResults }) => {
    const hardwareTestsToPass = ['digitizer', 'audio', 'backCamera', 'frontCamera'];
    const formattedKey = {
        digitizer: 'Touchscreen',
        audio: 'Audio',
        backCamera: 'Back Camera',
        frontCamera: 'Front Camera',
    };

    const hardwareResultSummary = useMemo(() => {
        if (!hardwareResults || Object.keys(hardwareResults).length === 0) {
            return [];
        }

        const results = hardwareTestsToPass.map(test => {
            const isFunctional = hardwareResults[test];
            const value = isFunctional ? 'Functional' : 'Non-functional';
            const color = isFunctional ? 'green' : 'red';

            return {
                key: formattedKey[test] || test,
                value,
                color,
            };
        });

        return results;
    }, [hardwareResults]);

    return (
        <BorderedBox styleProps={{ p: 0 }}>
            <Flex direction="row">
                <Flex
                    flexDir="column"
                    w="full"
                    maxW="container.sm"
                    bg="#F0F0F5"
                    borderRadius={8}
                    p={4}
                    border="1px solid"
                    borderColor="#D5D6DA"
                    m={4}
                >
                    <Box
                        bg="black"
                        py={1}
                        px={2}
                        borderRadius={8}
                        color="white"
                        w="fit-content"
                    >
                        Hardware Results
                    </Box>

                    {hardwareResultSummary.length === 0 ? (
                        <Skeleton height="20px" />
                    ) : (
                        <Grid
                            mt={4}
                            rowGap={4}
                            columnGap={6}
                            gridTemplateColumns="minmax(120px, auto) 1fr"
                        >
                            {hardwareResultSummary.map(({ key, value, color }) => (
                                <React.Fragment key={key}>
                                    <Text fontWeight={700}>{key}</Text>
                                    <HStack alignItems="flex-start">
                                        <Circle size="20px" bg={`${color}.500`} />
                                        <Text fontWeight={700}>{value}</Text>
                                    </HStack>
                                </React.Fragment>
                            ))}
                        </Grid>
                    )}
                </Flex>
            </Flex>
        </BorderedBox>
    );
};

export default HardwareResults;
